const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: [], 
    listaMotorista: [],
    listaVeiculo: [],
    listaMacro: [
        { id: 2, valor: 'INICIO DE JORNADA' },
        { id: 3, valor: 'PARADA PARA REFEICAO' },
        { id: 4, valor: 'DESCANSO' },
        { id: 5, valor: 'REINICIO DE VIAGEM' },
        { id: 6, valor: 'FIM DE JORNADA' },
        { id: 7, valor: 'BALSA/ PARE E SIGA' },
        { id: 8, valor: 'MANUTENCAO' },
        { id: 9, valor: 'DESCARGA' },
        { id: 10, valor: 'CARREGAMENTO' },
        { id: 11, valor: 'ABASTECIMENTO' },
        { id: 13, valor: 'CHEGADA NO CLIENTE' }

    ]
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'TEMPO_DIRECAO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'TEMPO_DIRECAO_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'TEMPO_DIRECAO_MOTORISTA_SELECT_LISTADO':
			return {
				...state,
				listaMotorista: action.payload.data
            };

        case 'TEMPO_DIRECAO_VEICULO_SELECT_LISTADO':
			return {
				...state,
				listaVeiculo: action.payload.data
            };
                      
        default:
            return state;
    }
}
